import React, {useCallback, useState} from 'react';
import {useIntl} from "react-intl";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import ClearIcon from '../ClearIcon';
import classnames from "classnames";
import styles from "./styles.module.scss";
import inputStyles from "../../styles/commonInput.module.scss";

const CACHE = {};

const FilterInputTypeahead = ({
                                fieldId,
                                value,
                                labelKey,
                                placeholder,
                                onChange,
                                setFieldValue,
                                renderMenuItemChildren,
                                dispatch,
                                typeaheadLabel = '',
                                customContainerStyles = '',
                                inputCustomStyles = '',
                                labelCustomStyles = '',
                                handleFindItem,
                                onClearValue,
                                ...rest
                              }) => {
  const intl = useIntl();
  const searchByCustomer = intl.formatMessage({id: 'filter-placeholder-customer', defaultMessage: 'Customer'});
  const [options, setOptions] = useState([]);
  const handleSearch = useCallback((query) => {
    if (CACHE[query]) {
      setOptions(CACHE[query].options);
      return;
    }
    handleFindItem(query).then((resp) => {
      setOptions(resp.options);
    });
  }, []);

  return (
    <div className={customContainerStyles}>
      {(value || placeholder !== searchByCustomer) && <div className={styles.filterLabel}>{searchByCustomer}</div>}
      <AsyncTypeahead
        id={fieldId}
        onSearch={handleSearch}
        onChange={onChange}
        filterBy={() => true}
        options={options}
        paginate={false}
        labelKey={labelKey}
        emptyLabel={intl.formatMessage({id: 'typeahead-search-empty-label', defaultMessage: 'Empty'})}
        searchText={intl.formatMessage({id: 'typeahead-search-text', defaultMessage: 'Search'})}
        promptText={intl.formatMessage({id: 'typeahead-prompt', defaultMessage: 'Type'})}
        renderInput={({inputRef, referenceElementRef, className, ...inputProps}) => (
          <label className={classnames(styles.inputContainer)}>
            <input
              id={fieldId}
              name={fieldId}
              value={value}
              placeholder={placeholder}
              className={classnames(
                inputStyles.input,
                inputCustomStyles,
                {[styles.customInput]: placeholder !== searchByCustomer})}
              type={'text'}
              ref={(input) => {
                inputRef(input);
                referenceElementRef(input);
              }}
              onChange={e => {
                setFieldValue(fieldId, e.target.value);
                inputProps.onChange(e);
              }}
              {...rest}
            />
          </label>
        )}
        renderMenuItemChildren={renderMenuItemChildren}
        useCache={false}
        isLoading={false}
      />
      <ClearIcon onClick={onClearValue}/>
    </div>
  )
};

export default FilterInputTypeahead;
